import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.vehicle-slider-cob' ).each( function( key, component ) {
        const splide = new Splide( $( component ).find( '.splide--vehicle-slider-cob' )[0], {
          type: 'fade',
          pagination: false,
          rewind: true,
          arrows: true,
          gap: '0px',
          autoWidth: false,
          perPage: 1,
          speed: 1000,
        } );

        splide.on( 'mounted', () => updateAdjacentClasses( splide.index ) );
        splide.on( 'move', ( newIndex ) => updateAdjacentClasses( newIndex ) );

        splide.mount();

        function updateAdjacentClasses( activeIndex ) {
          const realSlides = splide.Components.Slides.get().filter( ( s ) => !s.isClone );
          const total = splide.length;
          const nextIdx = ( activeIndex + 1 ) % total;
          const prevIdx = ( activeIndex - 1 + total ) % total;

          realSlides.forEach( ( slide ) => {
            slide.slide.classList.remove( 'is-custom-next', 'is-custom-prev' );
            if ( slide.index === nextIdx ) slide.slide.classList.add( 'is-custom-next' );
            if ( slide.index === prevIdx ) slide.slide.classList.add( 'is-custom-prev' );
          } );
        }


        $( document ).on( 'mouseenter', '.vscob__vehicle-link', function() {
          const target = $( this ).data( 'target' );
          console.log( target );

          $( target ).addClass( 'is-focused' );
        } ).on( 'mouseleave', '.vscob__vehicle-link', function() {
          const target = $( this ).data( 'target' );
          $( target ).removeClass( 'is-focused' );
        } );


        $( document ).on( 'focus', '.vscob__vehicle-link', function() {
          const target = $( this ).data( 'target' );
          console.log( target );

          $( target ).addClass( 'is-focused' );
        } ).on( 'blur', '.vscob__vehicle-link', function() {
          const target = $( this ).data( 'target' );
          $( target ).removeClass( 'is-focused' );
        } );
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'vehicle-slider-cob', COMPONENT );
} )( app );
